export default [
  {
    vid: "9578",
    name: "Test1",
    voiceContent:
      "Lorem ipsum, or lipsum as it is sometimes known.",
    status: "Active",
    createDate: "2021-11-02 16:29:58",
  },
  {
    vid: "9579",
    name: "Test2",
    voiceContent:
      "Lorem ipsum, or lipsum as it is sometimes known.",
    status: "Active",
    createDate: "2021-11-04 18:29:58",
  },
];
